import { createFileRoute } from '@tanstack/react-router';
import { JourneysSqlSyncNewHandoff } from '@/pages/workspaces/journeys/integrations/sql-sync/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/sql-sync/:type/new` URL. Flag off it renders the embedded Ember
 * host; flag on it forwards to the migrated URL, `?id` included.
 *
 * The resolver is required, not decorative: ownership claims the `/workspaces/last` form of this
 * URL, so the embedded app — which would otherwise resolve the sentinel itself — never mounts to do
 * it, and the handoff has no workspace id to forward to.
 */
function JourneysSqlSyncNewRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSqlSyncNewHandoff type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new',
)({
  component: JourneysSqlSyncNewRoute,
});
